<template>
    <v-container class="white--text copyright pa-0">
        <v-layout>
            <div>
                Zoologická zahrada hl. m. Prahy, U Trojského zámku 120/3, 171 00 Praha 7
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>

<style lang="scss">
    .copyright {
        font-size: 12px;
    }
</style>
